import * as React from "react";
import { ContainerQuery } from "react-container-query";
import { InstantCollapsible } from "sb-resp-ui";
import { marketColumnsDisplayMultiview } from "../../../../constants";
import { HeadingTitle } from "../HeadingTitle";
import { SecondaryHeadingWrap } from "../SecondaryHeadingWrap";
import { HeadingNamesWrap } from "../HeadingNamesWrap";
import { SecondaryHeading } from "../SecondaryHeading";
export class SecondaryHeadingWrapMultiview extends SecondaryHeadingWrap {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this */
    constructor(props) {
        super(props);
    }
    renderSubheading(params) {
        return React.createElement(SecondaryHeading, { componentPrefix: this.props.cardType },
            React.createElement(HeadingTitle, { name: this.props.name, eventsCount: this.props.eventsCount }),
            this.props.marketNames.length
                ? React.createElement(HeadingNamesWrap, { marketNames: this.props.marketNames, marketTemplates: this.props.marketTemplates, queryParams: params })
                : React.createElement(React.Fragment, null));
    }
    render() {
        return (React.createElement(InstantCollapsible, { initiallyExpanded: this.props.shouldExpand, trigger: React.createElement(ContainerQuery, { query: marketColumnsDisplayMultiview }, (params) => this.renderSubheading(params)), content: React.createElement(React.Fragment, null, this.props.children) }));
    }
}
//# sourceMappingURL=SecondaryHeadingWrapMultiview.js.map